import { render, staticRenderFns } from "./Patrones.vue?vue&type=template&id=e60170c6&"
import script from "./Patrones.vue?vue&type=script&lang=js&"
export * from "./Patrones.vue?vue&type=script&lang=js&"
import style0 from "./Patrones.vue?vue&type=style&index=0&id=e60170c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports